import React from "react";
import { compose } from "recompose";
import { withRouter } from "react-router";
import trackEvent from "theme/modules/Analytics/trackEvent";
import EnhanceAddMultipleItemsToCart from "./EnhanceAddMultipleItemsToCart";
import AddMultipleItemsToCartMutation from "./AddMultipleItemsToCartMutation.gql";
import OutOfStock from "../OutOfStock";
import BaseAddToCart from "../BaseAddToCart";
import logHandler from "web/core/logs/logHandler";
import { setAddToCartError } from "theme/modules/ProductAddedPopIn/useAddToCartError";

export const AddMultipleItemsToCart = ({
  appearance,
  addToCart,
  commandPending,
  label,
  message,
  itemList,
  unavailableLabel,
  disabled,
  actions,
}) => {
  if (itemList.every(({ product }) => !product?.stock?.isInStock)) {
    return <OutOfStock message={message} unavailableLabel={unavailableLabel} />;
  }

  return (
    <BaseAddToCart
      appearance={appearance}
      addToCart={() => addToCart()}
      message={message}
      state={commandPending ? "pending" : disabled ? "disabled" : undefined}
      label={label}
      actions={actions}
    />
  );
};

const trackProductAdded = (product, qty) => {
  const currency = product?.prices?.finalPrice?.priceInclTax?.value?.currency;
  trackEvent("Product Added", {
    qty,
    currency,
    sku: product.sku,
    name: product.name,
    price: product.price,
  });
};

export default compose(
  withRouter,
  EnhanceAddMultipleItemsToCart({
    AddMultipleItemsToCartMutation,
    addToCartCallback:
      ({ onProductAdded, product, itemList, location, history }) =>
      ({ status, data }) => {
        if (status === "success") {
          try {
            if (product) {
              // Tracking the parent product
              trackProductAdded(product, 1);
            }
            // Tracking the addition of the actual products added to the cart
            itemList.forEach(({ product, qty }) =>
              trackProductAdded(product, qty)
            );
          } catch (error) {
            logHandler.getLogger().error(error);
          }

          if (data.errorMessage) {
            setAddToCartError(history, location, data.errorMessage);
          }

          onProductAdded(data);
        }
      },
  })
)(AddMultipleItemsToCart);
